import { useCallback, useEffect, useRef } from 'react';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';

const SliderThumbs = ({ images, setActive, active = 0 }) => {
    const containerRef = useRef();

    const prev = useCallback(() => {
        const newIndex = active === 0 ? images.length - 1 : active - 1;
        setActive(newIndex);
    }, [setActive, images, active]);
    
    const next = useCallback(() => {
        const newIndex = active === images.length - 1 ? 0 : active + 1;
        setActive(newIndex);
    }, [setActive, images, active]);

    const handleThumbClick = useCallback((index) => {
        setActive(index);
    }, [setActive]);

    useEffect(() => {
        if (containerRef.current) {
            const activeElement = containerRef?.current.children[active];
            const parentDims = containerRef?.current.getBoundingClientRect();
            const activeDims = activeElement?.getBoundingClientRect();
            if (activeDims?.right > parentDims?.right) {
                containerRef.current.scrollLeft = (activeDims.right - parentDims.right) + containerRef.current.scrollLeft;
            }
            
            if (activeDims?.left < parentDims?.left) {
                containerRef.current.scrollLeft = containerRef.current.scrollLeft - (parentDims.left - activeDims.left);
            }
        }
    }, [active, containerRef]);

    return (
        <div className="slider-thumbs">
            <span className="icon" onClick={prev}>
                <FontAwesomeIcon icon={faChevronLeft} />
            </span>
            <div className="thumbs-container" ref={containerRef}>
                {images.map((image, i) => (
                    <div 
                        key={i} 
                        onClick={() => handleThumbClick(i)} 
                        className={`slider-thumb ${active === i ? 'active' : ''}`}
                    />
                ))}
            </div>
            <span className="icon" onClick={next}>
                <FontAwesomeIcon icon={faChevronRight} />
            </span>
        </div>
    )
}

export default SliderThumbs;